import { render, staticRenderFns } from "./PostOfficeBox.vue?vue&type=template&id=812200f4&scoped=true"
import script from "./PostOfficeBox.vue?vue&type=script&lang=js"
export * from "./PostOfficeBox.vue?vue&type=script&lang=js"
import style0 from "./PostOfficeBox.vue?vue&type=style&index=0&id=812200f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812200f4",
  null
  
)

export default component.exports